// src/pages/dashboardadmindata/expand/ViewRecipeExpand.jsx

import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector }              from "react-redux";
import Chart                                     from "chart.js/auto";
import Modal                                     from "react-bootstrap/Modal";
import { Card, CardBody }                        from "../../../components/card/card.jsx";
import {
  fetchAdminViewRecipeAdditionalData
}                                                from "../../../actions/dashboardadmin_actions";

import "bootstrap-daterangepicker/daterangepicker.css";
import "react-datepicker/dist/react-datepicker.css";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";

const $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs5");
require("datatables.net-buttons");
require("datatables.net-buttons/js/buttons.colVis.min.js");
require("datatables.net-buttons/js/buttons.html5.min.js");
require("datatables.net-buttons/js/buttons.print.min.js");
require("datatables.net-buttons-bs5");
require("datatables.net-responsive");
require("datatables.net-responsive-bs5");
require("datatables.net-fixedcolumns");
require("datatables.net-fixedcolumns-bs5");

const ViewRecipeExpand = React.memo(
  ({ data, labels, values, themeColor, themeColorRgb, bodyBg }) => {
    const dispatch     = useDispatch();
    const chartRef     = useRef(null);
    const tableRef     = useRef(null);
    const modalRef     = useRef(null);
    const [show, setShow]           = useState(false);
    const [datelabel, setDatelabel] = useState("");
    const [fullscreen]              = useState(true);

    const {
      viewRecipeAdditionalData,
      loadingViewRecipeAdditionalData,
      viewRecipeAdditionalDataError
    } = useSelector(state => ({
      viewRecipeAdditionalData:        state.dashboardadmin.viewRecipeAdditionalData,
      loadingViewRecipeAdditionalData: state.dashboardadmin.loadingViewRecipeAdditionalData,
      viewRecipeAdditionalDataError:   state.dashboardadmin.viewRecipeAdditionalDataError
    }));

    // 1) Chart
    useEffect(() => {
      if (!chartRef.current) return;
      const chart = new Chart(chartRef.current, {
        type: "line",
        data: {
          labels,
          datasets: [{
            label:                 "Views Over Time",
            data:                  values,
            borderColor:           themeColor,
            borderWidth:           1.5,
            fill:                  false,
            pointBackgroundColor:  bodyBg,
            pointBorderWidth:      1.5,
            pointRadius:           4,
            pointHoverBackgroundColor: themeColor,
            pointHoverBorderColor:     bodyBg,
            pointHoverRadius:          7
          }]
        },
        options: { responsive: true, maintainAspectRatio: false }
      });
      return () => chart.destroy();
    }, [labels, values, themeColor, themeColorRgb, bodyBg]);

    // 2) Details Over Time
    useEffect(() => {
      if (!tableRef.current) return;
      const dt = $(tableRef.current).DataTable({
        data: [...(data?.dateswise || [])].reverse(),
        columns: [
          {
            title: "Serial Number",
            data: null,
            render: (_d,_t,_r,meta) => meta.row + 1
          },
          { title: "Date",   data: "label" },
          { title: "Counts", data: "value" },
          {
            title: "Details",
            data: null,
            render: (_d,_t,row) =>
              `<button class='btn btn-primary btn-sm view-details' 
                       data-row='${JSON.stringify(row)}'>
                 View
               </button>`
          }
        ],
        destroy:    true,
        responsive: true
      });

      $(tableRef.current)
        .off("click", ".view-details")
        .on("click", ".view-details", function () {
          const rowData = $(this).data("row");
          const [table, startTime, endTime] = rowData.Details
            .match(/\(([^,]+),([^,]+),([^)]+)\)/)
            .slice(1);
          setDatelabel(rowData.label);
          dispatch(fetchAdminViewRecipeAdditionalData(
            Number(startTime),
            Number(endTime)
          ));
          setShow(true);
        });

      return () => dt.destroy();
    }, [data, dispatch]);

    // 3) Modal table
    useEffect(() => {
      if (!modalRef.current) return;
      const dt = $(modalRef.current).DataTable({
        data: viewRecipeAdditionalData || [],
        columns: [
          { title: "ID",                  data: "id" },
          { title: "Curated Recipe",      data: "curatedRecipeName" },
          { title: "Custom Recipe",       data: "customRecipeName" },
          { title: "Username",            data: "username" },
          {
            title: "Base Ingredients",
            data: "baseIngredients",
            render: raw => {
              const arr = JSON.parse(raw || "[]");
              return arr
                .map(i => `${i.name}: ${i.quantity} [ML]`)
                .join("<br>");
            }
          },
          {
            title: "Mixture Ingredients",
            data: "mixtureIngredients",
            render: raw => {
              const arr = JSON.parse(raw || "[]");
              return arr
                .map(i => `${i.name}: ${i.quantity} [ML]`)
                .join("<br>");
            }
          },
          {
          title: "Created",
          data:  "created",
          render: ts => {
            const d = new Date(ts * 1000);
            return d.toLocaleString("en-US", {
              month:  "2-digit",
              day:    "2-digit",
              year:   "numeric",
              hour:   "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true
            });
          }
        },
        {
          title: "Updated",
          data:  "updated",
          render: ts => {
            const d = new Date(ts * 1000);
            return d.toLocaleString("en-US", {
              month:  "2-digit",
              day:    "2-digit",
              year:   "numeric",
              hour:   "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true
            });
          }
        }
        ],
        destroy:    true,
        responsive: true,
        rowId:      "id"
      });
      return () => dt.destroy();
    }, [viewRecipeAdditionalData]);

    return (
      <>
        <h1>View Recipes</h1>

        <section className="accordion mb-2" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
              >
                Chart Over Time
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ height: '400px', overflow: 'hidden' }}>
                <canvas ref={chartRef} className="w-100" height="450" />
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
              >
                Details Over Time
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse show"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <table
                  ref={tableRef}
                  className="table table-striped table-responsive w-100"
                />
              </div>
            </div>
          </div>
        </section>

        <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Recipe Views – {datelabel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card>
              <CardBody>
                {loadingViewRecipeAdditionalData && (
                  <div className="spinner-border" />
                )}
                {viewRecipeAdditionalDataError && (
                  <div className="text-danger">
                    {viewRecipeAdditionalDataError}
                  </div>
                )}
                {!loadingViewRecipeAdditionalData &&
                  !viewRecipeAdditionalDataError && (
                  <table
                    ref={modalRef}
                    className="table table-striped table-responsive w-100"
                  />
                )}
              </CardBody>
            </Card>
          </Modal.Body>
        </Modal>
      </>
    );
  }
);

export default ViewRecipeExpand;
